import { InputNumber } from 'antd'

export const InputNumeric = (props) => {

  const minCount = (value) => {
    if (value.groupSize) {
      return parseInt(value.groupSize);
    } else {
      if (value.variants) {
        return parseInt(value.variants.reserved);
      } else {
        return 0;
      }
    }
  }

  return <InputNumber min={minCount(props)} style={{ minWidth: '200px' }} {...props} />
}
